/** The six approved preset names. Stops live on the server. */
export const STYLE_PRESETS = [
  { id: 'cozy', name: 'Cozy' },
  { id: 'gritty', name: 'Gritty' },
  { id: 'breakneck', name: 'Breakneck' },
  { id: 'epic', name: 'Epic' },
  { id: 'quiet-and-close', name: 'Quiet and Close' },
  { id: 'gothic', name: 'Gothic' },
];
